


















import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class extends Vue {
  @Model('input', { type: Boolean })
  readonly value: boolean;

  get showDialog() {
    return this.value;
  }

  set showDialog(d) {
    this.$emit('input', d);
  }

  @Prop({ required: false }) readonly dialogTitle: string;
  @Prop({ required: false, default: 'Confirm' })
  readonly confirmButtonText: string;

  dialogConfirm() {
    this.$emit('dialog-confirm');
  }
}
